const outsourcingCustomizationsModel = vm => ({
  title: vm.$gettext('Outsourcing Customizations'),
  endpoint: 'outsourcing/customizations',
  allowNew: true,
  allowDelete: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      editable: true,
      description: vm.$gettext('The name of the customization'),
      type: 'text',
      required: true
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      editable: true,
      description: vm.$gettext('Customization description'),
      type: 'text'
    },
    {
      key: 'model_type',
      label: vm.$gettext('Entity'),
      editable: true,
      description: vm.$gettext('Indicates to which kind of entity this customization applies'),
      type: 'select',
      options: [{ text: vm.$gettext('Company'), value: 'Api\\Companies\\Models\\Company' }],
      required: true,
      default: 'Api\\Companies\\Models\\Company'
    },
    {
      key: 'value_validations',
      label: vm.$gettext('Value Validations'),
      editable: true,
      description: vm.$gettext('Validations to apply to a value when setting a customization'),
      type: 'text'
    }
  ],
  filters: ['name', 'model_type']
})

export default outsourcingCustomizationsModel
